import { render, staticRenderFns } from "./EntityDetailsPanels.vue?vue&type=template&id=589b73b2"
import script from "./EntityDetailsPanels.vue?vue&type=script&lang=js"
export * from "./EntityDetailsPanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports